module.exports = __webpack_public_path__ + "static/main_laptop-cda849c0febc39b999637efad184b06a.png";